export const OVER_UNDER = 'OVER_UNDER' as const;
export const SCORE = 'SCORE' as const;
export const SPREAD = 'SPREAD' as const;
export const WIN = 'WIN' as const;
export const PLAYER = 'PLAYER' as const;
export const PLAYER_PROP = 'PLAYER_PROP' as const;
export const WinMarket = 'Win Market' as const;
export const PointSpread = 'Point Spread' as const;
export const TotalPoints = 'Total Points' as const;
export const TotalRuns = 'Total Runs' as const;
export const Moneyline = 'Moneyline' as const;
export const TotalGoalsOverUnder = 'Total Goals Over/Under' as const;
export const TotalGoalsFirstHalf = 'Total Goals - 1st Half' as const;
export const TotalGoalsSecondHalf = 'Total Goals - 2nd Half' as const;

// Italian translations
export const Vincente = 'Vincente' as const;
export const DifferenzaPunti = 'Differenza Punti' as const;
export const TotalePunti = 'Totale Punti' as const;
export const TotaleRuns = 'Totale Runs' as const;
export const MoneylineIt = 'Moneyline' as const;
export const TotaleGoalOverUnder = 'Totale Goal Over/Under' as const;
export const TotaleGoalPrimoTempo = 'Totale Goal - 1° Tempo' as const;
export const TotaleGoalSecondoTempo = 'Totale Goal - 2° Tempo' as const;

export const marketTypes = [OVER_UNDER, SCORE, SPREAD, WIN] as const;

export const marketMeta = {
  [Moneyline]: {
    heading: 'Moneyline (ML)',
    info: 'Moneyline Odds',
    betsTooltipText: `The % of the total number of bets on the moneyline placed on each team.`,
    moneyTooltipText: `The % of the total money wagered on the moneyline bet on each team.`,
  },
  [PointSpread]: {
    heading: 'Spread',
    info: 'Spread Line',
    betsTooltipText: `The % of the total number of bets on the spread placed on each team`,
    moneyTooltipText: `The % of the total money wagered on the spread bet on each team.`,
  },
  [TotalPoints]: {
    heading: '',
    info: '',
    betsTooltipText: `The % of the total number of bets on the total points placed on the over or the under.`,
    moneyTooltipText: `The % of the total money wagered on the total points bet on the over or the under.`,
  },
  [TotalRuns]: {
    heading: '',
    info: '',
    betsTooltipText: `The % of the total number of bets on the total runs placed on the over or the under.`,
    moneyTooltipText: `The % of the total money wagered on the total runs bet on the over or the under.`,
  },
  [WinMarket]: {
    heading: 'Win Market',
    info: 'Win Market Odds',
    betsTooltipText: `The % of the total number of bets on the win market placed on each team.`,
    moneyTooltipText: `The % of the total money wagered on the win market bet on each team.`,
  },
  [TotalGoalsOverUnder]: {
    heading: 'Total Goals Over/Under',
    info: 'Total Goals Over/Under Odds',
    betsTooltipText: `The % of the total number of bets on the total goals over/under placed on the over or the under.`,
    moneyTooltipText: `The % of the total money wagered on the total goals over/under bet on the over or the under.`,
  },
  [TotalGoalsFirstHalf]: {
    heading: 'Total Goals - 1st Half',
    info: 'Total Goals - 1st Half Odds',
    betsTooltipText: `The % of the total number of bets on the total goals - 1st half placed on the over or the under.`,
    moneyTooltipText: `The % of the total money wagered on the total goals - 1st half bet on the over or the under.`,
  },
  [TotalGoalsSecondHalf]: {
    heading: 'Total Goals - 2nd Half',
    info: 'Total Goals - 2nd Half Odds',
    betsTooltipText: `The % of the total number of bets on the total goals - 2nd half placed on the over or the under.`,
    moneyTooltipText: `The % of the total money wagered on the total goals - 2nd half bet on the over or the under.`,
  },
};

export const marketMetaIt = {
  [MoneylineIt]: {
    heading: 'Moneyline (ML)',
    info: 'Quota Moneyline',
    betsTooltipText: `La % del numero totale di scommesse sulla moneyline piazzate su ciascuna squadra.`,
    moneyTooltipText: `La % del denaro totale scommesso sulla moneyline su ciascuna squadra.`,
  },
  [DifferenzaPunti]: {
    heading: 'Spread',
    info: 'Linea Spread',
    betsTooltipText: `La % del numero totale di scommesse sullo spread piazzate su ciascuna squadra.`,
    moneyTooltipText: `La % del denaro totale scommesso sullo spread su ciascuna squadra.`,
  },
  [TotalePunti]: {
    heading: '',
    info: '',
    betsTooltipText: `La % del numero totale di scommesse sul totale punti piazzate sull'over o sull'under.`,
    moneyTooltipText: `La % del denaro totale scommesso sul totale punti sull'over o sull'under.`,
  },
  [TotaleRuns]: {
    heading: '',
    info: '',
    betsTooltipText: `La % del numero totale di scommesse sul totale runs piazzate sull'over o sull'under.`,
    moneyTooltipText: `La % del denaro totale scommesso sul totale runs sull'over o sull'under.`,
  },
  [Vincente]: {
    heading: 'Mercato Vincente',
    info: 'Quota Mercato Vincente',
    betsTooltipText: `La % del numero totale di scommesse sul mercato vincente piazzate su ciascuna squadra.`,
    moneyTooltipText: `La % del denaro totale scommesso sul mercato vincente su ciascuna squadra.`,
  },
  [TotaleGoalOverUnder]: {
    heading: 'Totale Goal Over/Under',
    info: 'Quote Totale Goal Over/Under',
    betsTooltipText: `La % del numero totale di scommesse sul totale goal over/under piazzate sull'over o sull'under.`,
    moneyTooltipText: `La % del denaro totale scommesso sul totale goal over/under sull'over o sull'under.`,
  },
  [TotaleGoalPrimoTempo]: {
    heading: 'Totale Goal - 1° Tempo',
    info: 'Quote Totale Goal - 1° Tempo',
    betsTooltipText: `La % del numero totale di scommesse sul totale goal - 1° tempo piazzate sull'over o sull'under.`,
    moneyTooltipText: `La % del denaro totale scommesso sul totale goal - 1° tempo sull'over o sull'under.`,
  },
  [TotaleGoalSecondoTempo]: {
    heading: 'Totale Goal - 2° Tempo',
    info: 'Quote Totale Goal - 2° Tempo',
    betsTooltipText: `La % del numero totale di scommesse sul totale goal - 2° tempo piazzate sull'over o sull'under.`,
    moneyTooltipText: `La % del denaro totale scommesso sul totale goal - 2° tempo sull'over o sull'under.`,
  },
};
